const q1H = [
  {
    insert: ' ',
  },
  {
    insert: '1',
    attributes: { script: 'super' },
  },
  {
    insert: 'H NMR (400 MHz, TFH-d8 [2.09 ppm], ppm) δ = ',
  },
  {
    insert: '6.41 (quint, ',
  },
  {
    insert: 'J',
    attributes: { italic: true },
  },
  {
    insert: ' = 1.8 Hz, 3H), ',
  },
  {
    insert: '8.05 (ddd, ',
  },
  {
    insert: 'J',
    attributes: { italic: true },
  },
  {
    insert: ' = 0.7, ',
  },
  {
    insert: 'J',
    attributes: { italic: true },
  },
  {
    insert: ' = 2.0, ',
  },
  {
    insert: 'J',
    attributes: { italic: true },
  },
  {
    insert: ' = 37.4, 3H), ',
  },
  {
    insert: '14.95 (s, 1H)',
  },
  {
    insert: '.',
  },
];

const qIR = [
  {
    insert: ' ',
  },
  {
    insert: 'IR (ATR, ṽ) = 3542 (vw), 1750 (m), 1266 (vs) cm',
  },
  {
    insert: '-1',
    attributes: { script: 'super' },
  },
  {
    insert: '. ',
  },
];

const q13C = 'TBD';

export {
  q1H, qIR, q13C,
};
